import React from 'react';
import { Container } from 'react-bootstrap';
import courierImg from '../../../assets/images/sahari-courier.webp';
import boxesImg from '../../../assets/images/courier-boxes.webp';
import fleetImg from '../../../assets/images/shipping.webp';
import Button from '../../../components/ui/Button';
import { ScrollText, Reveal, Stagger, StaggerItem, ParallaxImage } from '../../../components/motion';
import Eyebrow from '../../../components/ui/Eyebrow';
import styles from './AboutSection.module.css';

const POINTS = [
  'Door to door — we collect and we deliver',
  'Customs cleared by us at both ends',
  'Every box packed, numbered and tracked',
];

const STATS = [
  { value: '100k+', label: 'boxes delivered' },
  { value: '12', label: 'branches in Saudi' },
  { value: '11', label: 'countries served' },
];

/**
 * About Us on Home — the story on the left; on the right a red card with
 * the numbers, then Sahari's own courier, boxes and plane & truck (every
 * photo carries the brand).
 */
const AboutSection: React.FC = () => {
  return (
    <section className={styles.about}>
      <Container fluid="xl" className={styles.inner}>
        <div className={styles.grid}>
          <div className={styles.left}>
            <Eyebrow>About Sahari Cargo</Eyebrow>
            <ScrollText
              as="h2"
              className={styles.title}
              accentWords={[4, 5, 6, 7]}
              accentClassName={styles.accent}
            >
              Your boxes, from Saudi to your family's door
            </ScrollText>
            <Reveal as="p" className={styles.description} delay={0.05}>
              Sahari Cargo is a cargo and courier company headquartered in
              Riyadh, with 12 branches across Saudi Arabia. We send air cargo
              and sea freight to India, Pakistan, the Philippines, Bangladesh,
              Nepal, Sri Lanka, Malaysia, Singapore, Brunei, Hungary and the
              United Kingdom.
            </Reveal>
            <Stagger as="ul" className={styles.points} stagger={0.08}>
              {POINTS.map((p) => (
                <StaggerItem key={p} as="li" direction="up" className={styles.point}>
                  <span className={styles.check} aria-hidden="true">
                    ✓
                  </span>
                  {p}
                </StaggerItem>
              ))}
            </Stagger>
            <Reveal delay={0.15} className={styles.ctas}>
              <Button to="/about" variant="primary">
                Learn more →
              </Button>
              <Button to="/tracking" variant="outline">
                Track a box
              </Button>
            </Reveal>
          </div>

          <div className={styles.right}>
            <Reveal className={styles.stats}>
              {STATS.map((s) => (
                <div key={s.label} className={styles.stat}>
                  <b>{s.value}</b>
                  <span>{s.label}</span>
                </div>
              ))}
            </Reveal>
            <ParallaxImage
              src={courierImg}
              alt="Sahari Cargo courier with a Sahari Cargo box"
              className={`${styles.photo} ${styles.courier}`}
              amount={6}
            />
            <ParallaxImage
              src={boxesImg}
              alt="Sahari Cargo boxes with the red Sahari tape"
              className={styles.photo}
              amount={6}
            />
            <ParallaxImage
              src={fleetImg}
              alt="Sahari Cargo plane and truck"
              className={`${styles.photo} ${styles.wide}`}
              amount={6}
            />
          </div>
        </div>
      </Container>
    </section>
  );
};

export default AboutSection;
